import { MonthLoadProgress } from '@krp/ui-kit'

import '../../../shared/ui/onec.css'
import type { CashReceiptsScreenActions, CashReceiptsScreenVm } from '../model/types'
import { CashReceiptsScreen, type CashReceiptsExtras } from './CashReceiptsScreen'

/**
 * «Статистика по продажам» базы 1С: выручка за месяц и день, приход, возвраты, итог, график по дням и ожидаемая выручка — поверх
 * тех же дерева, фильтров и списка, что во вкладке «Чеки». Сводки видят не все, кто видит сами чеки (право `sales.read`).
 * Экран получает vm и actions и больше ничего.
 */
export function CashSalesStatisticsScreen({ vm, actions }: { vm: CashReceiptsScreenVm; actions: CashReceiptsScreenActions }) {
  const extras: CashReceiptsExtras = {
    stats: vm.stats,
    statsBusy: vm.statsBusy ?? (vm.query.status === 'loading' || vm.progressNote !== null),
    notices: (
      <>
        <MonthLoadProgress parts={vm.loadParts} onRetry={actions.retryMonths} />
        {vm.progressNote !== null && vm.loadParts.length < 2 && <p className="onec-field__note" role="status">{vm.progressNote}</p>}
        {vm.boundsNote !== null && <p className="onec-field__note" role="status">{vm.boundsNote}</p>}
      </>
    ),
    trend: vm.trend,
    periodTrend: vm.periodTrend,
    trendBusy: vm.trendQuery?.status === 'loading' || vm.trendQuery?.status === 'idle',
    todayBusy: vm.todayBusy,
    ...(vm.trendQuery?.error != null ? { trendMessage: vm.trendQuery.error.message } : {}),
  }
  return <CashReceiptsScreen vm={vm} actions={actions} extras={extras} receipts={false} />
}
